import { FormStateInitialValues, FormValuesOutput } from '@policygenius/mortar-dynamic-forms';
import { DatapointvaluesDPIDValueItem } from 'api';
import { buildBodyFromInterview } from 'api/hooks/useDataPointValues';
import pick from 'lodash/pick';

import { MARIJUANA_URNS, RECREATIONAL_MARIJUANA_URNS } from '.';
import {
  addDataTypeToBooleanDPIDs,
  createVirtualMultiChoiceDPID,
  virtualToBooleanDPIDs,
} from '../utils';
import schema from './schema';
import { FormValues } from './types';

export const buildInitialValues = (
  values: Record<string, any> | undefined
): FormStateInitialValues<FormValues> => ({
  ...pick(values, MARIJUANA_URNS),
  'urn:pg:data-point:virtual-insured-risk-condition-marijuana-recreational-usage-method':
    createVirtualMultiChoiceDPID(values, RECREATIONAL_MARIJUANA_URNS),
});

export const buildSubmissionValues = (
  values: FormValuesOutput<FormValues>
): DatapointvaluesDPIDValueItem[] => {
  const marijuanaRecreationalUsageMethods = virtualToBooleanDPIDs(
    values['urn:pg:data-point:virtual-insured-risk-condition-marijuana-recreational-usage-method'],
    RECREATIONAL_MARIJUANA_URNS
  );

  return [
    ...addDataTypeToBooleanDPIDs(marijuanaRecreationalUsageMethods, RECREATIONAL_MARIJUANA_URNS),
    ...buildBodyFromInterview(pick(values, MARIJUANA_URNS), schema),
  ];
};
